export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '1f4fae44-e9e4-44e0-b64b-1bbc12187227';
export const MODAL_CLOSE_SEC = 2.5;
